const texts = {
    en: {
        heading: 'Lender Registration',
        subHeading: 'Company Profile',
        labelName: 'Full Name',
        labelEmail: 'Email',
        labelContactNumber: 'Contact Number',
        labelRecaptcha: "Re-CAPTCHA",
        submitButtonText: 'Submit',
        namePlaceholder: 'Legal Name',
        nameValidationError: 'Please enter a valid name',
        contactNumberValidationError: 'Please enter a valid phone number',
        emailValidationError: 'Please enter a valid email',
        captchaValidationError: "Please re-submit captcha",
        successMessage: 'Thank you for registering. We will get in touch with you soon.',
    },
    id: {
        heading: 'Pendaftaran Pemberi Dana',
        subHeading: 'Profil Perusahaan',
        labelName: 'Nama Lengkap',
        labelEmail: 'Email',
        labelContactNumber: 'Nomor Telepon',
        labelRecaptcha: "Re-CAPTCHA",
        submitButtonText: 'Kirim',
        namePlaceholder: 'Nama Sah',
        nameValidationError: 'Mohon ketik nama yang benar',
        contactNumberValidationError: 'Mohon masukkan nomor yang benar',
        emailValidationError: 'Mohon masukkan email yang benar',
        captchaValidationError: "Tolong kerjakan kembali captcha",
        successMessage: 'Terima kasih telah mendaftar. Kami akan hubungi anda segera.',
    }
}

export default texts
